import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { EquipmentTransfer, ListItem, RepositoryModal } from '../../shared'
import { AvailabilityComponent } from './availability.component'

@Component({
    templateUrl: './transfer.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class TransferComponent extends RepositoryModal<EquipmentTransfer> implements OnInit {
    jobMap: ListItem<string>[] = []
    jobMap2: ListItem<string>[] = []
    equipmentMap: ListItem<string>[] = []
    userMap: ListItem<string>[] = []

    ngOnInit() {
        const availabilityComponent = this.editOptions.initializeParams as AvailabilityComponent
        this.userMap = availabilityComponent.activeUserMap.collectionView.items.map(x => new ListItem(x.id, x.name))
    }

    protected onInitialized() {
        const availabilityComponent = this.editOptions.initializeParams as AvailabilityComponent

        if (!this.target.requestedById) {
            this.target.requestedById = availabilityComponent.activeUserMap.collectionView.items.filter(
                x => x.id == this.services.authentication.hrref,
            )[0].id
        }

        const jobMap1 = availabilityComponent.allJobs
            .orderByDescending(x => x.id)
            .map(x => new ListItem(x.id + ' ' + x.name, x.id + ' ' + x.name))
        jobMap1.unshift(new ListItem('VanCon HQ / Shop', 'VanCon HQ / Shop'))
        this.jobMap = jobMap1

        const jobMap2 = availabilityComponent.allJobs
            .orderByDescending(x => x.id)
            .map(x => new ListItem(x.id + ' ' + x.name, x.id + ' ' + x.name))
        jobMap2.unshift(new ListItem('VanCon HQ / Shop', 'VanCon HQ / Shop'))
        this.jobMap2 = jobMap2

        this.equipmentMap = availabilityComponent.grid.items.map(x => new ListItem(x.equipment, x.description))
    }
}
